export { default } from './BasePage';
export * from './BasePage';
